import { Text, Stack, Heading, Box } from 'braid-design-system';
import React from 'react';

import type { ListingProduct } from 'src/generated/graphql';
import type { UsePostListingStatus } from 'src/hooks/usePostListing';

import { PaymentSuccessCta } from './PaymentSuccessCTA';
import { PaymentSuccessLayout } from './PaymentSuccessContainer';
import {
  PostListingFeedback,
  shouldRenderPostListingFeedback,
} from './PostListingFeedback';

interface GenericPaymentSuccessProps {
  product: ListingProduct;
  postListingStatus: UsePostListingStatus;
}

export const GenericPaymentSuccess = ({
  product,
  postListingStatus,
}: GenericPaymentSuccessProps) => (
  <Box data={{ testid: 'generic-payment-success' }}>
    <PaymentSuccessLayout
      callToAction={
        <PaymentSuccessCta>
          {postListingStatus.kind === 'idle' ? 'Create an ad' : 'Next'}
        </PaymentSuccessCta>
      }
    >
      <Stack space="large">
        <Heading level="3">Success!</Heading>
        <Text>You bought a {product.description}</Text>
        {postListingStatus.kind === 'idle' && (
          <Text>Now let&#39;s create an ad.</Text>
        )}

        {/* Temp: bring back old listings post as GraphQL implementation doesn't work */}
        {shouldRenderPostListingFeedback({
          loading: postListingStatus.kind === 'loading',
          error: postListingStatus.kind === 'error',
          success: postListingStatus.kind === 'success',
        }) && (
          <PostListingFeedback
            loading={postListingStatus.kind === 'loading'}
            error={postListingStatus.kind === 'error'}
            success={postListingStatus.kind === 'success'}
          />
        )}
      </Stack>
    </PaymentSuccessLayout>
  </Box>
);
